import React from 'react';
import { View, Text, StyleSheet, ScrollView } from 'react-native';

const Termos = () => {
  return (
    <View style={styles.container}>
      <ScrollView>
        <Text style={styles.title}>Termos e Condições de Uso</Text>
        <Text style={styles.content}>
  Equipe Velox, Bem-Vindo! {'\n\n'}
  A Velox é um aplicativo que busca melhorar a eficiência e a qualidade das entregas empresariais, utilizando através da tecnologia, uma plataforma que vincula a empresa a motoentregador disponíveis a levar o pedido ao cliente, de forma rápida e lucrativa, não existindo um nicho específico para seu funcionamento. {'\n\n'}
  
  O motoentregador devidamente cadastrado, tem a total liberdade de escolher os pedidos criados pelas empresas, tendo um suporte prestativo e online 24 (vinte e quatro) horas para atender suas necessidades, entre os tipos de pedidos existentes, a possibilidade de a empresa criar alguns modelos de entrega, com suas taxas fixadas de acordo com a região. {'\n\n'}

  Atente-se às Regras! {'\n\n'}
  
  A empresa irá pagar uma taxa fixa para o uso da plataforma, e uma taxa fixa para as modalidades de entrega, não é permitido a alteração desses valores ou o pagamento diferente do pré-estabelecido. {'\n\n'}

  Motoentregador deve ter mais de 18 anos, CNH categoria mínima A com EAR válida, veículo com a documentação em dia, veículo com a cilindragem mínima 125 CC, e no mínimo fabricação e modelo do veículo 2012/2013. {'\n\n'}

  O aplicativo não tem um nicho específico de entrega, a empresa criadora do pedido tem que atender às limitações de um motoentregador, seja no tamanho e peso do produto. {'\n\n'}

  É estritamente proibido o uso da plataforma para o transporte de produtos ilícitos, perigosos, animais vivos ou qualquer item que viole as legislações vigentes. O descumprimento desta regra resultará em banimento imediato da plataforma. {'\n\n'}

  Após aceitação do pedido, motoentregador tem um tempo de 20 (vinte) minutos para chegar na empresa e retirar o pedido, após esse prazo, fica opcional o cancelamento da entrega, dando a oportunidade para a empresa chamar um novo motoentregador. {'\n\n'}

  Em fase de entrega do pedido, o motoentregador tem um prazo de 25 (vinte e cinco) minutos para finalizar o pedido com o código, caso tenha algum problema em seu trajeto, o motoentregador deve comunicar a empresa criadora do pedido para informar o ocorrido ou entrar em contato com o suporte. {'\n\n'}

  O motoentregador deve manter uma conduta profissional perante a empresa e o cliente, mantendo o respeito e a boa imagem da plataforma. {'\n\n'}

  Todos os usuários da plataforma, sejam empresas ou motoentregadores, devem agir com respeito e profissionalismo em todas as interações realizadas através da Velox. Comportamentos inadequados poderão resultar em medidas disciplinares, incluindo bloqueio temporário ou permanente da conta. {'\n\n'}

  Para o motoentregador, a utilização da plataforma é gratuita, tendo apenas a obrigação de respeitar as políticas da plataforma. {'\n\n'}

  O motoentregador pode cancelar o pedido a qualquer momento, porém nos casos onde ele esteja com o produto em rota de entrega, ele deve retornar à empresa criadora do pedido para a devolução, mantendo o bom estado e a integridade do produto e da embalagem. {'\n\n'}

  Caso o motoentregador cancele o pedido e retorne para a empresa com o produto danificado ou com a embalagem violada, será aplicado uma multa no valor do pedido para o motoentregador, a situação recorrente pode levar ao bloqueio permanente. {'\n\n'}

  É proibido utilizar e se aproveitar de bugs e erros do sistema para adquirir vantagens, caso a empresa ou o motoentregador, se deparar com alguma anomalia, reporte para o suporte, dependendo da gravidade será dada uma gratificação para quem o encontrou. {'\n\n'}

  A empresa que cancelar o pedido após o motoentregador estiver em trajeto de entrega, deve pagar o valor integral da taxa, independente do motivo do cancelamento. {'\n\n'}

  A Velox atua exclusivamente como uma plataforma intermediária que conecta empresas e motoentregadores. Não temos responsabilidade direta sobre a execução das entregas, condições dos produtos ou quaisquer danos decorrentes de falhas no serviço, salvo o que for explicitamente descrito nestes Termos. {'\n\n'}

  Ao utilizar a plataforma Velox, você concorda com a coleta, armazenamento e uso de seus dados pessoais conforme descrito na nossa Política de Privacidade. Esses dados serão utilizados exclusivamente para a operação do serviço e comunicação entre os usuários da plataforma. {'\n\n'}

  Em caso de violações às regras da plataforma, como uso inadequado, dano intencional a produtos ou não cumprimento das taxas devidas, a Velox reserva-se o direito de aplicar penalidades, incluindo multas, suspensão ou bloqueio da conta. {'\n\n'}

  A Velox reserva-se o direito de alterar os Termos e Condições a qualquer momento. Recomendamos revisar este documento regularmente. Em caso de disputas, fica eleito o foro da Comarca de Planaltina-GO para dirimir quaisquer questões relativas a este contrato. {'\n\n'}

  Isenção de Responsabilidade por Acidentes: {'\n\n'}

  A Velox atua exclusivamente como intermediária entre empresas e motoentregadores autônomos, não havendo qualquer vínculo empregatício ou responsabilidade direta sobre as condições de trabalho, deslocamento ou segurança dos motoentregadores. A Velox não se responsabiliza por acidentes, danos pessoais, materiais ou quaisquer prejuízos sofridos pelo motoentregador durante a execução de entregas realizadas por meio da plataforma. {'\n\n'}

  A Velox recomenda que todos os motoentregadores utilizem equipamentos de proteção individual (EPI), como capacetes e outros acessórios de segurança, além de respeitar as leis de trânsito e conduzir com prudência. {'\n\n'}

  A responsabilidade por eventuais acidentes, danos ou infrações de trânsito recai exclusivamente sobre o motoentregador, que é responsável por suas próprias decisões e condutas ao utilizar a plataforma. {'\n\n'}

  Aceitamos sugestões de melhorias da plataforma, com um suporte online 24 (vinte e quatro) horas, nosso objetivo é simplificar as entregas, a plataforma se encontra em um estado de DEMO, bugs e erros podem acontecer, porém, estamos aqui para solucionar qualquer problema e garantir a satisfação dos usuários e clientes. Obrigado pela atenção! {'\n\n'}

  att: equipe Velox
</Text>

      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    backgroundColor: '#f8f8f8',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 20,
    textAlign: 'center',
  },
  content: {
    fontSize: 16,
    color: '#555',
    lineHeight: 24,
  },
});

export default Termos;
